"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstraintFactory = void 0;
const FieldValueConstraint_1 = require("./FieldValueConstraint");
const CompositeConstraint_1 = require("./CompositeConstraint");
/**
 * Ruleset constraint factory.
 */
class ConstraintFactory {
    /**
     * Instantiate a constraint configured with the passed in configuration.
     * @param config
     */
    static create(config) {
        if (ConstraintFactory.constraints[config.type]) {
            return ConstraintFactory.constraints[config.type](config);
        }
        throw { message: `Unknown constraint type ${config.type}` };
    }
    /**
     * Registers a new constraint type.
     * @param constraintType the name of the new constraint type
     * @param factory a factory method that will accept a configuration as input and will return a new instance of the constraint
     */
    static register(constraintType, factory) {
        this.constraints[constraintType] = factory;
    }
}
exports.ConstraintFactory = ConstraintFactory;
ConstraintFactory.constraints = {
    [FieldValueConstraint_1.NAME]: (config) => new FieldValueConstraint_1.FieldValueConstraint(config),
    [CompositeConstraint_1.NAME]: (config) => new CompositeConstraint_1.CompositeConstraint(config),
};
//# sourceMappingURL=ConstraintFactory.js.map